<box class="transfers-history-filter-main-container">
  <form
    [formGroup]="formGroup"
    (ngSubmit)="submit()"
    autocomplete="off"
    class="entry-form"
  >
    <box class="field-set">
      <app-request-date-control
        class="col-sm-12 col-lg-12 col-md-12"
        label="From Date"
        placeholder="From Date"
        formControlName="fromDate"
        [minDate]="state.fromMinDate"
        [maxDate]="state.maxDate"
      ></app-request-date-control>

      <app-request-date-control
        class="col-sm-12 col-lg-12 col-md-12"
        label="To Date"
        placeholder="To Date"
        formControlName="toDate"
        [minDate]="state.toMinDate"
        [maxDate]="state.maxDate"
      ></app-request-date-control>
    </box>

    <!-- <div style="display: none">button added</div> -->
  </form>

  <div class="filter-form-btn">
    <box class="filter-form-btn-grp">
      <button type="button" (click)="resetForm()" class="btn-link">
        <span>Reset</span>
      </button>
      <button
        *ngIf="formGroup"
        type="button"
        (click)="submitForm()"
        class="button-common button40 active"
        [disabled]="!formGroup.valid || state.isDateValid"
      >
        <span>Submit</span>
      </button>
    </box>
  </div>
</box>
